import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";
import api from "../lib/api";
import { Spinner, Pill } from "./common";

export default function CuratedArticles() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/articles", { params: { limit: 30 } }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);

  if (!items) return <Spinner />;
  if (items.length === 0) return <p className="text-sm text-muted-foreground">No articles yet.</p>;

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="curated-articles">
      {items.map((a) => (
        <Link key={a.slug} to={`/articles/${a.slug}`} data-testid={`article-card-${a.slug}`}
          className="group border border-zinc-300 bg-white p-6 hover:-translate-y-px hover:border-primary transition-[transform,border-color]">
          <Newspaper className="w-5 h-5 text-primary mb-3" />
          <h3 className="font-heading font-700 text-lg leading-snug">{a.title}</h3>
          <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{a.summary}</p>
          <div className="mt-4 flex flex-wrap gap-1">{a.tags?.map((t) => <Pill key={t}>{t}</Pill>)}</div>
        </Link>
      ))}
    </div>
  );
}
